import { DeviceIconContent, type DeviceIconContentProps } from './device-icon-content';
import { useSubscribeDeviceIconRefs } from './use-subscribe-device-icon-refs';

type DeviceIconProps = DeviceIconContentProps;

/**
 * Returns the device icon component (one row: subscribes to this icon's refs).
 * For tables with many icons, use `useSubscribeDeviceIconRefs` + `DeviceIconContent` instead.
 */
export const DeviceIcon = ({ icon, ...rest }: DeviceIconProps) => {
  useSubscribeDeviceIconRefs([icon]);
  return <DeviceIconContent icon={icon} {...rest} />;
};
